var _excluded = ["type", "disableToggle", "isTextVisible", "isReadOnly", "isViewMode", "isDisabled", "getToggleVisibilityAriaLabel"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { forwardRef, useBoolean } from '../../../utils';
import { useMultiStyleConfig } from '../../../utils/use-style-config';
import { IconButton } from '../../action';
import { Box } from '../../internal';
import { TextField } from '../TextField';
import { jsx as _jsx } from "react/jsx-runtime";
export var SecuredTextField = forwardRef((_ref, ref) => {
  var _getToggleVisibilityA;

  var {
    type = 'text',
    disableToggle = false,
    isTextVisible = false,
    isReadOnly,
    isViewMode,
    isDisabled,
    getToggleVisibilityAriaLabel
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  var [textVisible, showText] = useBoolean(isTextVisible);
  var [isFocused, setIsFocused] = useBoolean(false);
  var [isHover, setIsHover] = useBoolean(false);
  var hideToggleButton = disableToggle || isReadOnly || isViewMode;
  var buttonProps = {};

  if ((isFocused || isHover) && !isDisabled) {
    buttonProps['data-active'] = true;
  }

  var styles = useMultiStyleConfig('SecuredTextField', {
    textVisible
  });
  var ariaLabel = (_getToggleVisibilityA = getToggleVisibilityAriaLabel === null || getToggleVisibilityAriaLabel === void 0 ? void 0 : getToggleVisibilityAriaLabel(textVisible)) !== null && _getToggleVisibilityA !== void 0 ? _getToggleVisibilityA : "Toggle visibility ".concat(textVisible ? 'off' : 'on');
  var rightElement = !hideToggleButton ? /*#__PURE__*/_jsx(Box, {
    __css: styles['inputRightIcon'],
    children: /*#__PURE__*/_jsx(IconButton, {
      size: "small",
      icon: textVisible ? 'hide' : 'show',
      variant: "naked",
      onClick: isReadOnly || isViewMode ? undefined : showText.toggle,
      isDisabled: !props.value || isDisabled,
      "aria-label": ariaLabel,
      "data-testid": "toggle".concat(props.id ? "-".concat(props.id) : '', "-input-visibility")
    })
  }) : undefined;
  return /*#__PURE__*/_jsx(TextField // `type` should be set to 'text' when `textVisible` is true to prevent the password from being masked if `type` is set to 'password'.
  , _objectSpread(_objectSpread({
    type: textVisible ? 'text' : type,
    onFocus: setIsFocused.on,
    onBlurCapture: setIsFocused.off,
    ref: ref,
    "data-component": "SecuredTextField",
    isViewMode: isViewMode,
    isReadOnly: isReadOnly,
    isDisabled: isDisabled
  }, props), {}, {
    sx: styles['container'],
    rightElement: rightElement,
    onMouseOver: setIsHover.on,
    onMouseOut: setIsHover.off
  }));
});
SecuredTextField.displayName = 'SecuredTextField';
//# sourceMappingURL=SecuredTextField.js.map